export default __webpack_public_path__ + "static/media/sumatoria_azul.fa2b81d5.svg";